// This file manages exports from the base atom, molecule, or organism.
// Use named rather than default exports.

// This file manages exports from the base atom, molecule, or organism.
import { EditableComponent, EditableComponentProps } from '@adobe/aem-react-editable-components';
import dynamic from 'next/dynamic';

// Use named rather than default exports.
import { AccountRefreshNotificationProps } from './AccountRefreshNotification.types';
const AccountRefreshNotification = dynamic(() =>
  import('./AccountRefreshNotification').then(mod => mod.AccountRefreshNotification)
);

export const AccountRefreshNotificationConfig = {
  emptyLabel: 'accountrefreshnotification',
  isEmpty: () => true,
  resourceType: `mi-aem-account/components/content/inlinemessaging`,
};

type editableCompAccountRefreshNotificationProps = EditableComponentProps & AccountRefreshNotificationProps;

export const AccountRefreshNotificationEditable = (props: editableCompAccountRefreshNotificationProps) => (
  <EditableComponent config={AccountRefreshNotificationConfig} {...props}>
    <AccountRefreshNotification {...props} />
  </EditableComponent>
);
